import { render } from "./ReceivingVoucherAdd.vue?vue&type=template&id=2af6b60c"
import script from "./ReceivingVoucherAdd.vue?vue&type=script&lang=js"
export * from "./ReceivingVoucherAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__